import { axios, BaseApiUrl } from '../axios_config';

// 根据运输方式统计待拣货数
export const getPickCount = params =>{
    return axios.post(`${BaseApiUrl}/WaitPick/GetWaitPickNumByTransportType`,{ ...params }).then(res => res.data);
}

// 根据SKU查询库位信息
export const getPickQuerySkuStorage = params =>{
    return axios.post(`${BaseApiUrl}/WaitPick/GetWaitPickQuerySkuStorage`, { ...params }).then(res => res.data);
}

// 根据货柜号查询SKU拣货信息
export const GetWaitPickContainerNoQuerySku = params =>{
    return axios.post(`${BaseApiUrl}/WaitPick/GetWaitPickContainerNoQuerySku`, { ...params }).then(res => res.data);
}

// 根据货柜号维度查询拣货信息
export const GetWaitPickInfoByContainerNo = params =>{
    return axios.post(`${BaseApiUrl}/WaitPick/GetWaitPickInfoByContainerNo`, { ...params }).then(res => res.data);
}

// 根据SKU维度查询拣货信息
export const GetWaitPickInfoBySku = params =>{
    return axios.post(`${BaseApiUrl}/WaitPick/GetWaitPickInfoBySku`, { ...params }).then(res => res.data);
}

// 确认下架 
export const ConfirmOffShelf = params =>{
    return axios.post(`${BaseApiUrl}/WaitPick/ConfirmOffShelf`, [...params]).then(res => res.data);
}

// 校验库位信息 校验库位对应的SKU有无库存
export const CheckStorageAndStock = params =>{
    return axios.post(`${BaseApiUrl}/WaitPick/CheckStorageAndStock`, {...params}).then(res => res.data);
}


// 查询公司对应待出库仓库
export const GetWaitOutWarehouseList = params =>{
    return axios.get(`${BaseApiUrl}/Util/GetWaitOutWarehouseList`, { params }).then(res => res.data);
}



